import React from "react";

export function FilterChip({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <div className="
      flex items-center gap-2
      h-[32px]
      px-3
      rounded-full
      border border-[#1E1C26]
      font-raleway
      text-[12px]
      font-medium
      tracking-[0%]
      text-[#3E3A4C]
      ">
      <span>{label}</span>
      <button
        onClick={onRemove}
        className="text-[#6B7280] hover:text-black"
        type="button"
      >
        ✕
      </button>
    </div>
  );
}
